























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, State, Mutation } from 'vuex-class';
import ActivityIndicator from '@/components/ActivityIndicator.vue';
import DiscordLabel from '@/components/DiscordLabel.vue';
import { SocketState, User, CombatGame } from '@/types';
import { CombatCharacter, Attack, InventoryItem } from '@/game/types';
import _ from 'underscore';
import { TweenMax } from 'gsap';
import io from 'socket.io-client';
import api from '@/api';
import GameController from '@/game/places/combat';
import AudioManager from '@/game/audio-manager';

interface MasterObjectOption {
  id: string;
  title: string;
  description: string;
  to: null|string;
  disabled: boolean;
  select: {
    id: string;
    type: string;
  } | null;
}
interface GuiMasterObject {
  [root: string]: MasterObjectOption[];
  potions: MasterObjectOption[];
  attacks: MasterObjectOption[];
  actions: MasterObjectOption[];
}

@Component({
  components: { ActivityIndicator, DiscordLabel },
})
export default class CombatRoom extends Vue {
  @State public user!: User;
  @State public socket!: SocketState;
  @State public combatGame!: CombatGame;
  @Action public socketJoinRoom: any;
  @Action public socketLeaveRoom: any;
  @Action public SOCKET_EMIT: any;
  @Mutation public SET_HEADER_VISIBILITY: any;
  @Mutation public SET_COMBAT_GAME_STATE: any;
  @Mutation public SET_COMBAT_GAME_SELECTION_MODE: any;
  @Mutation public RESET_GAME_STATE: any;
  @Mutation public SET_SOCKET_ROOM: any;

  public roomLink = window.location.href;
  public roomConnection: -1 | 0 | 1 | string = -1; // -1 = not pending, 0 = pending, 1 = ok, 'string' = error

  public hotTip = '';

  public gameInterface = GameController();
  public currentScreen = 'root';
  public currentCursorIndex = 0;
  public cursorMoveDate = Date.now();

  public mounted() {
    this.SET_HEADER_VISIBILITY(false);

    // add event listeners
    document.addEventListener('keydown', this.keyMonitor, true);
    window.addEventListener('resize', this.gameInterface.resizeMonitor, true);

    this.hotTip = _.sample([
      'Coordinates with others players to make the most effective use of your attacks and items!',
      'Different enemies have different gold and xp rewards!',
      'Completely finishing levels rewards all players in gold. Yay gold!',
      'You can buy potions to heal yourself or other players in combat. Hooray, teamwork!',
      'Enemies become stronger as you advance. Keep yourself strong by upgrading your defense and power!',
      'Leveling up in combat regenerates your health 100%!',
    ]);

    // combat hub connection attempt
    if (this.socket.connected && this.user.authenticated) {
      this.attemptConnection();
    }
  }
  public updated() {
    const { user, socket, roomConnection } = this;
    // on disconnect socket
    if (!socket.connected && roomConnection !== -1) {
      this.roomConnection = -1;
    }
    // combat hub connection attempt
    if (socket.connected && user.authenticated && roomConnection === -1) {
      this.attemptConnection();
    }
  }
  public destroyed() {
    if (this.gameInterface) {
      this.gameInterface.destroyGame();
    }
    this.SET_HEADER_VISIBILITY(true);
    this.SOCKET_EMIT(['COMBAT_ROOM_LEAVE']);
    this.RESET_GAME_STATE('COMBAT_ROOM');
    document.removeEventListener('keydown', this.keyMonitor, true);
    window.removeEventListener('resize', this.gameInterface.resizeMonitor, true);
  }
  public attemptConnection() {
    if (!this.socket.connected) {
      return;
    }
    if (this.roomConnection !== -1) {
      return;
    }

    const { roomID } = this.$route.params;
    this.roomConnection = 0;

    this.SOCKET_EMIT(['COMBAT_ROOM_CONNECT', roomID, (err?: string, combatRoom?: CombatRoom) => {
      if (err) {
        this.roomConnection = err;
      } else {
        this.roomConnection = 1;
        if (!this.gameInterface.game) {
          this.SET_COMBAT_GAME_STATE(combatRoom);
          this.gameInterface.launch();
        }
      }
    }]);
  }
  public keyMonitor(event: any) {
    if (Date.now() - this.cursorMoveDate <= 100 || this.gameInterface.isAnimating) {
      return;
    }
    this.cursorMoveDate = Date.now();

    if (this.combatGame.selectionMode === 'ACTION' && this.currentPlayerSelectionStatus === 0) {
      const key = event.key.toUpperCase();

      if (key === 'W' || key === 'ARROWUP') {
        this.moveCursor('up');
      } else if (key === 'A' || key === 'ARROWLEFT') {
        this.moveCursor('left');
      } else if (key === 'S' || key === 'ARROWDOWN') {
        this.moveCursor('down');
      } else if (key === 'D' || key === 'ARROWRIGHT') {
        this.moveCursor('right');
      } else if (key === 'ENTER') {
        this.selectOption();
      }
    } else {
      this.gameInterface.keyMonitor(event);
    }
  }
  public moveCursor(direction: string) {
    const options = this.currentScreenObject;
    const currentIndex = this.currentCursorIndex;
    let nextIndex = currentIndex;
    let j = currentIndex;

    // Move the cursor index
    if (direction === 'up') {
      if (currentIndex > 0) {
        j--;
      } else {
        j = options.length - 1;
      }
    } else if (direction === 'down') {
      if (currentIndex < options.length - 1) {
        j++;
      } else {
        j = 0;
      }
    } else {
      return;
    }

    this.setCursorIndex(j);
  }
  public setCursorIndex(index: number) {
    if (this.currentCursorIndex != index && this.combatGame.selectionMode === 'ACTION') {
      AudioManager.playOnce('cursorMove');
      this.currentCursorIndex = index;
    }
  }
  public selectOption() {
    const currentScreenObj = this.guiMasterObject[this.currentScreen];
    const currentIndex = this.currentCursorIndex;
    const selectedOption: MasterObjectOption = currentScreenObj[currentIndex];

    if (!selectedOption || selectedOption.disabled) {
      return;
    }

    AudioManager.playOnce('cursorSelect');

    // this is a route
    if(selectedOption.to) {
      this.currentCursorIndex = 0;
      this.currentScreen = selectedOption.to;
    } else if (selectedOption.select) {
      this.gameInterface.selectAction(selectedOption.select);
    }
  }
  public eventDescription(id: string): string {
    if (!this.gameInterface.gameInitialized) {
      return '';
    }

    const characters = {...this.gameInterface.gameState.players, ...this.gameInterface.gameState.enemies};
    const character = characters[id];

    if (!character) {
      return '...';
    }

    const queuedEvents = this.gameInterface.gameState.queuedEvents;
    const characterEvent = _.find(queuedEvents, (event) => {
      return event.character.id === id;
    });

    if (character.entity.health === 0) {
      return 'Dead.';
    }
    if (!characterEvent) {
      return 'Waiting...';
    }

    let spotInLine = 0;
    _.each([
      ..._.values(this.gameInterface.playerPlacingLine),
      ..._.values(this.gameInterface.enemyPlacingLine)
    ],
    (spot) => {
      if (spotInLine) { return };
      if (!!spot.character && String(spot.character.id) == id) {
        spotInLine = spot.index;
      }
    });

    const receiver = characters[characterEvent.receiver.id];

    // labelName examples:
    // self, Slime#2, Skepdimi
    const labelName = String(receiver.id) == String(id)
      ? 'self'
      : receiver.username + (receiver.enemy ? `#${spotInLine}` : '');

    return `<strong>${character.username}</strong> chose ${characterEvent.action.type} <strong>${characterEvent.action.id.replace(/-/gi, ' ')}</strong> on <strong>${labelName}</strong>`;
  }
  public copyLink() {
    /* Get the text field */
    const copyText = document.getElementById("link-input") as HTMLInputElement;

    if (!copyText) {
      return;
    }

    copyText.select();
    document.execCommand("copy");

    /* Alert the copied text */
    const linkCopyLabel = document.getElementById('link-copy-label');
    if (!linkCopyLabel) {
      return;
    }

    linkCopyLabel.innerHTML = 'Copied URL to clipboard!';
    TweenMax.fromTo(
      linkCopyLabel,
      0.5,
      { opacity: 0 },
      { opacity: 1 },
    );
    TweenMax.to(
      linkCopyLabel,
      0.8,
      {
        opacity: 0,
        delay: 2,
        onComplete() {
          linkCopyLabel.innerHTML = '';
        },
      },
    );
  }
  public guiWakeup() {
    this.currentCursorIndex = 0;
    this.currentScreen = 'root';
    this.SET_COMBAT_GAME_SELECTION_MODE('ACTION');
    AudioManager.playOnce('cursorBack');
  }
  get guiMasterObject() {
    let guiMasterObject: GuiMasterObject = {
      root: [],
      potions: [
        ],
      attacks: [
        ],
      actions: [
        ],
    };
    if (!this.gameInterface.gameInitialized) {
      return guiMasterObject
    }

    const currentPlayer: CombatCharacter | null = this.currentPlayer;

    if (!currentPlayer) {
      return guiMasterObject;
    }

    // PARSE ROOT
    const parsedRoot: MasterObjectOption[] = [
      { id: 'attacks', title: 'Attacks', description: '', to: 'attacks', disabled: false, select: null },
      { id: 'potions', title: 'Potions', description: '', to: 'potions', disabled: false, select: null },
    ];

    // push them to the guiMasterObject
    guiMasterObject.root = parsedRoot;

    // PARSE ATTACKS
    const attacks = currentPlayer.entity.attacks;

    guiMasterObject.attacks.push({
      id: 'back',
      title: 'Back',
      to: 'root',
      description: '',
      disabled: false,
      select: null,
    });

    _.pairs(attacks).forEach((pair: [string, Attack]) => {
      const id = pair[0];
      const attackInfo = pair[1];
      const disabled = attackInfo.stats.energy > currentPlayer.entity.energy;
      guiMasterObject.attacks.push({
        id: attackInfo.name,
        title: attackInfo.name,
        description: !disabled
          ?
          `
            Description - <br/>
            ${attackInfo.description} <br/>
            Stats - <br/>
            Energy: ${attackInfo.stats.energy} <br/>
            Base dmg: ${attackInfo.stats.baseDamage}
          ` : `Description - <br/> ...`,
        to: null,
        disabled,
        select: {
          type: 'attack',
          id,
        },
      });
    });
    // PARSE POTIONS
    guiMasterObject.potions.push({
      id: 'back',
      title: 'Back',
      to: 'root',
      description: '',
      disabled: false,
      select: null,
    });
    const potions = _.filter(currentPlayer.inventory, (i: InventoryItem) => i.type === 'potion');

    potions.forEach((item) => {
      guiMasterObject.potions.push({
        id: item.id,
        title: item.uids.length > 1 ? `${item.name} (${item.uids.length})` : item.name,
        description: `
          Name: ${item.name} <br/>
          Quantity: ${item.uids.length}
        `,
        to: null,
        disabled: item.uids.length === 0,
        select: {
          type: 'item',
          id: item.id,
        },
      });
    });

    if (this.combatGame.selectionMode === 'ACTION') {
      let selectedOption = guiMasterObject[this.currentScreen][this.currentCursorIndex];
      let currentPlayer = this.currentPlayer;

      if (!selectedOption) {
        this.currentScreen = 'root';
        this.currentCursorIndex = 0;
        selectedOption = guiMasterObject.root[0];
      }

      if (!this.gameInterface.isAnimating) {
        if (selectedOption.disabled || (currentPlayer && currentPlayer.entity.health === 0)) {
          this.gameInterface.highlightCharacters(false);
        } else if (
          this.currentScreen === 'attacks' ||
          selectedOption.id === 'attacks'
        ) {
          this.gameInterface.highlightCharacters('enemies');
        } else if (selectedOption.id === 'heal-potion') {
          this.gameInterface.highlightCharacters('players');
        } else {
          this.gameInterface.highlightCharacters(true);
        }
      }
    }
    return guiMasterObject;
  }
  get currentPlayer(): CombatCharacter | null {
    // if not authenticated
    const { id } = this.user;
    if (!id) {
      return null;
    }
    // if no game intialized
    if (!this.gameInterface.gameInitialized) {
      return null;
    }
    // if no user matching this user id
    if (!this.gameInterface.gameState.players.hasOwnProperty(id)) {
      return null;
    }
    return this.gameInterface.gameState.players[id];
  }
  get currentPlayerSelectionStatus(): number {
    if (!this.currentPlayer) {
      return 0;
    }
    return this.currentPlayer.selectionStatus;
  }
  get currentScreenObject() {
    if (this.combatGame.selectionMode === 'TARGET') {
      this.currentScreen = 'root';
      this.currentCursorIndex = 0;
    }
    return this.guiMasterObject[this.currentScreen];
  }
  get currentLevelRecord() {
    let level = this.gameInterface.gameState.level;
    return this.gameInterface.gameState.levelRecord[level]
  }
  get description() {
    const selectionStatus = this.combatGame.selectionMode;

    if (selectionStatus === 'HIDDEN') {
      return '';
    }
    if (selectionStatus === 'ACTION') {
      const selectionOption = this.guiMasterObject[this.currentScreen][this.currentCursorIndex];
      return selectionOption.description;
    }
    if (selectionStatus === 'TARGET') {
      const targetSide = this.gameInterface.currentTargetSide;
      const targetIndex = this.gameInterface.currentTargetIndex;
      const placingLine = targetSide === 0
        ? this.gameInterface.playerPlacingLine
        : this.gameInterface.enemyPlacingLine;
      const target = placingLine[targetIndex].character;
      const currentPlayer = this.currentPlayer;

      if (!target) {
        return '';
      }
      if (currentPlayer && target.id === currentPlayer.id) {
        return `
          <h2>${target.username}</h2>
        `;
      } else {
        return `
          <h2>${target.username}${target.enemy ? `#${targetIndex}` : ''}</h2>
          <ul>
            <li>HP: ${Math.round(target.entity.health * 10) / 10}/${target.entity.maxHealth}</li>
            ${
              target.enemy && target.entity.health != 0
              ? `
                <li>Gold: ${target.goldReward}</li>
                <li>XP: ${target.xpReward}</li>
              `
              : ''
            }
            <li>Power: ${target.power}</li>
            <li>Defense: ${target.defense}</li>
          </ul>
        `;
      }
    }
    return '';
  }
}
